import { getDateTime } from 'TCIUtils';

export function formatAssignments(assignments) {
  return assignments.map(assignment => formattedAssignment(assignment));
}

export function formattedAssignment(assignment) {
  return ({
    actions: '',
    assignment_label: assignment.assignment_label,
    assignment_location: assignment.assignment_location,
    assignment_models_hash: assignment.assignment_models_hash,
    can_destroy: assignment.can_destroy,
    can_edit_max_score: assignment.can_edit_max_score,
    classes: assignment.classes,
    classroom_assignment: assignment.classroom_assignment,
    connected_to_canvas: assignment.connected_to_canvas,
    connected_to_google: assignment.connected_to_google,
    connected_to_schoology: assignment.connected_to_schoology,
    created_at: assignment.created_at,
    dates_enforced: assignment.dates_enforced,
    direct_link: assignment.direct_link,
    due_datetime: getDateTime(assignment.due_datetime),
    first_lesson_id: assignment.first_lesson_id,
    first_unit_id: assignment.first_unit_id,
    grading_notebook_by: assignment.grading_notebook_by,
    has_sync_errors: assignment.has_sync_errors,
    id: assignment.id,
    lms_provider: assignment.lms_provider,
    lms_type: assignment.lms_type,
    max_score: assignment.max_score,
    name: assignment.name,
    not_finalized_on_lti: assignment.not_finalized_on_lti,
    notes: assignment.notes,
    pending_publish_on_google: assignment.pending_publish_on_google,
    randomize_answers: assignment.randomize_answers,
    show_answers_to_students: assignment.show_answers_to_students,
    staffer_id: assignment.staffer_id,
    start_datetime: getDateTime(assignment.start_datetime),
    status: assignment.status,
    students: assignment.num_students,
    teacher_display_name: assignment.teacher_display_name,
    teacher_name: assignment.teacher_name,
    updated_at: assignment.updated_at,
  });
}
